<div class="sd-container sd-container--variant-white">
  <div class="sd-headline sd-headline--size-3xl">{{ 'profile.contacts.title' | transloco }}</div>

  <wct-spacer />

  <div class="sd-leadtext">{{ 'profile.contacts.subtitle1' | transloco }}</div>
  <wct-spacer />
  <div class="sd-meta sd-meta--light">{{ 'profile.contacts.subtitle2' | transloco }}</div>

  <wct-spacer />
  <sd-4-5-1-divider></sd-4-5-1-divider>
  <wct-spacer />

  <div
    class="contacts"
    [wctApiCallInject]="contacts">
    @for (contact of contacts(); track $index) {
    <picture>
      <source srcset="{{ contact.contactData?.imageUrl || '' }}" />
      <img
        class="img-placeholder"
        [src]="fallbackImage"
        alt="" />
    </picture>
    <div>
      <div class="sd-paragraph">
        <b>{{ contact.contactData?.firstName }} {{ contact.contactData?.lastName }}</b>
      </div>

      <wct-spacer [spacingAmount]="0.4"></wct-spacer>

      @for (role of contact.contactData?.roles; track $index) {
      <div class="sd-paragraph">{{ role }}</div>
      }

      <wct-spacer [spacingAmount]="0.4"></wct-spacer>

      <sd-4-5-1-link href="tel:{{ contact.contactData?.phoneNumber }}">
        {{ contact.contactData?.phoneNumber }}
      </sd-4-5-1-link>
      <sd-4-5-1-link href="mailto:{{ contact.contactData?.mailAddress }}">
        {{ contact.contactData?.mailAddress }}
      </sd-4-5-1-link>
    </div>
    } @empty {
    <div style="height: 192px"></div>
    }
  </div>

  <wct-spacer />
  <sd-4-5-1-divider></sd-4-5-1-divider>
  <wct-spacer />
  <div class="sd-meta sd-meta--light">{{ 'profile.contacts.technicalSupport' | transloco }}</div>
  <p><span [innerHTML]="'profile.contacts.technicalSupportText' | transloco"></span> <sd-4-5-1-link href="mailto:institutional@union-investment.de">institutional&#64;union-investment.de</sd-4-5-1-link></p>

</div>
